import { TextField, TextFieldProps } from '@mui/material'
import { ReactElement } from 'react'
import { Control, Controller, FieldError, Path } from 'react-hook-form'

interface IArtisanForm<T> {
  control: Control<T>
  name: Path<T>
  label?: string
  error?: FieldError
  required?: boolean
  endAdornment?: JSX.Element
  additionnalOnChange?: (value: string) => string
}

export default function InputTextControl<T>({
  control,
  name,
  label,
  error,
  required = false,
  endAdornment,
  additionnalOnChange,
  ...props
}: Readonly<IArtisanForm<T> & Omit<TextFieldProps, 'error'>>): ReactElement {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <TextField
          {...field}
          label={label}
          onChange={(e) => {
            const value = additionnalOnChange ? additionnalOnChange(e.target.value ?? '') : e.target.value
            field.onChange(value)
          }}
          error={!!error}
          helperText={error?.message ?? ''}
          fullWidth
          InputProps={{
            ...(endAdornment && { endAdornment }),
          }}
          {...props}
        />
      )}
    />
  )
}
